import { Grid, Stack, Typography } from "@mui/material";
import colors from "assets/theme/base/colors";
import MDBox from "components/MDBox";
import React from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";

const RouterSettings = () => {
  const { grey, primary, secondary } = colors;
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { path: "client-priority", name: "Client Priority Configuration" },
    { path: "client-config", name: "Client Configuration" },
    { path: "client-buyer", name: "Client Buyer Configuration" },
    // { path: "survey-priority", name: "Survey Priority Configuration" },
    { path: "recommendation-sort", name: "Recommendation Sort Configuration" },
    { path: "supplier-margin", name: "Supplier Margin Configuration" },
    { path: "fill-rate", name: "Fill Rate Configuration" },
    { path: "supplier-blocked", name: "Router Supplier Blocked Configuration" },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={3}>
        <MDBox
          py={2}
          mt={1}
          sx={{
            background: "white",
            borderRadius: "0.5rem",
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            pb="0.5rem"
            px={1.5}
            sx={{ borderBottom: `1px solid ${grey[400]}` }}
          >
            <Typography variant="v6" fontWeight="600" sx={{ color: "black" }}>
              Configuration
            </Typography>
          </Stack>

          <Stack
            sx={{
              height: "calc(100vh - 163px)",
              overflowY: "auto",
            }}
          >
            {tabs.map((tab, i) => {
              const isSelected = location.pathname.includes(tab.path);
              return (
                <MDBox
                  onClick={() => navigate(`/router-configurations/${tab.path}`)}
                  key={i}
                  sx={{
                    borderBottom: isSelected
                      ? `1px solid ${primary.main}`
                      : `1px solid #E4E4E4`,
                    background: isSelected ? `${secondary.light} !important` : "",
                    cursor: "pointer",
                    "&:hover": {
                      background: "#f5f5f5",
                    },
                  }}
                  py={1}
                  px={2}
                >
                  <Typography
                    sx={{
                      fontWeight: "500",
                      fontSize: "14px",
                      color: "black",
                      width: "100%",
                    }}
                  >
                    {tab.name}
                  </Typography>
                </MDBox>
              );
            })}
          </Stack>
        </MDBox>
      </Grid>
      <Grid item xs={9}>
        <MDBox
          p={1}
          mt={1}
          mr={0.8}
          sx={{
            background: "white",
            borderRadius: "0.5rem",
          }}
        >
          <Outlet /> {/* renders the selected child route */}
        </MDBox>
      </Grid>
    </Grid>
  );
};

export default RouterSettings;
